export const ADDRESS_FLAG = 'ADDRESS_FLAG';
export const ADDRESS_FLAG_False = 'ADDRESS_FLAG_False';